/* offer-badge.js — optional: pauses badge animations while off-screen */
(function () {
  if (window.__obInit) return;
  window.__obInit = true;
  if (!('IntersectionObserver' in window)) return;
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { e.target.classList.toggle('ob--off', !e.isIntersecting); });
  }, { rootMargin: '120px' });
  var queued = false;
  function scan() {
    queued = false;
    document.querySelectorAll('.ob:not([data-ob])').forEach(function (el) {
      el.setAttribute('data-ob', '1');
      io.observe(el);
    });
  }
  function queue() { if (!queued) { queued = true; requestAnimationFrame(scan); } }
  queue();
  new MutationObserver(queue).observe(document.documentElement, { childList: true, subtree: true });
})();